import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import RiderFeedbackForm from '#/user/components/RiderFeedbackForm';
import DetailViewLayout from '#/components/DetailViewLayout';
import DetailNavHeader from '#/shared/components/DetailNavHeader';
import useNavigate from '#/shared/hooks/useNavigate';
import useViewMapControls from '#/map/hooks/useViewMapControls';
import useCurrentQueryRequest from '#/shared/hooks/useCurrentQueryRequest';
import formstackConfig from '#/user/formstackConfig';
import ROUTES from '#/constants/routes';

function RiderFeedbackContainer() {
  const { generateNavigateBack, generateNavigateClose } = useNavigate();
  const { simpleStopViewOpened, viewClosed } = useViewMapControls();
  const { currentQueryRequest } = useCurrentQueryRequest();
  const redirectAfterSubmit = generateNavigateBack([], ROUTES.home);

  useEffect(() => {
    simpleStopViewOpened();
    return viewClosed;
  }, [simpleStopViewOpened, viewClosed]);

  return (
    <DetailViewLayout
      top={
        <DetailNavHeader
          onBack={generateNavigateBack()}
          onClose={generateNavigateClose()}
          content={<FormattedMessage id="feedback.form-title" />}
        />
      }
      bottom={
        <RiderFeedbackForm
          formstackConfig={formstackConfig}
          tripUrl={currentQueryRequest}
          redirectAfterSubmit={redirectAfterSubmit}
        />
      }
      hasInverseBackground
    />
  );
}

RiderFeedbackContainer.propTypes = {};

export default RiderFeedbackContainer;
